<template>
    <div class="planet">
        <span id="accordion-anchor" class="planet-button planet-button__safe" :class="{ 'focus__safe focus': safeFocus }"
            @click="openSafe">
        </span>
        <span class="planet-button planet-button__anonymous" :class="{ 'focus__anonymous focus': anonFocus }"
            @click="openAnonymous">
        </span>
        <span class="planet-button planet-button__alerts" :class="{ 'focus__alerts focus': alertsFocus }"
            @click="openAlerts">
        </span>
        <span class="planet-button planet-button__web" :class="{ 'focus__web focus': webFocus }" @click="openWeb">
        </span>

        <span class="planet-dark__top"></span>
        <span class="planet-dark__bottom"></span>
    </div>
</template>
<script>
import openAccordion from '@/mixins/openAccordion';
export default {
    props: {
        safeFocus: {
            type: Boolean,
            default: true
        },

        anonFocus: {
            type: Boolean,
            default: false
        },

        alertsFocus: {
            type: Boolean,
            default: false
        },

        webFocus: {
            type: Boolean,
            default: false
        }
    },

    mixins: [openAccordion],
}
</script>
<style scoped lang="scss">
.planet {
    height: 675px;
    width: 675px;
    position: relative;
    top: 218px;
    left: 20px;
    border-radius: 675.482px;
    border: 1px solid #A165C7;
    background: url("../../../public/images/planetBack2.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 582px;
}

.planet-button {
    position: absolute;
    height: 96px;
    width: 96px;
    border-radius: 50%;
    cursor: pointer;
}

.planet-button:hover svg,
.planet .focus__safe svg,
.planet .focus__anonymous svg,
.planet .focus__alerts svg,
.planet .focus__web svg {
    opacity: 0;
}

.planet-button__safe {
    top: -49px;
    left: 41%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-size: 58px;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='58' viewBox='0 0 60 58' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='30.001' cy='29.001' r='29.001' fill='white' fill-opacity='0.18'/%3E%3Cg filter='url(%23filter0_f_908_35551)'%3E%3Cpath d='M30.0464 17.4417L17.5905 39.4993L12.0018 39.5253L10 43.0703L47.4106 42.7021L49.4125 39.1572L42.8241 39.232L41.553 37.1215L37.6805 37.2075L38.8379 39.2897L23.2069 39.4241L24.4302 37.2577L35.1031 37.1807L33.3113 34.1558L28.6887 34.078L30.913 30.1391L29.6572 28.0014L30.8806 25.835L35.5789 33.813L39.6267 33.761L32.8874 22.2812L36.3022 16.2341L33.4662 11.3857L30.0464 17.4417Z' fill='url(%23paint0_linear_908_35551)'/%3E%3Cpath d='M14.4209 45.1122L15.0603 43.9798L45.5167 43.6457L46.166 44.7915L14.4209 45.1122Z' fill='url(%23paint1_linear_908_35551)'/%3E%3C/g%3E%3Cpath d='M30.0464 17.4417L17.5905 39.4993L12.0018 39.5253L10 43.0703L47.4106 42.7021L49.4125 39.1572L42.8241 39.232L41.553 37.1215L37.6805 37.2075L38.8379 39.2897L23.2069 39.4241L24.4302 37.2577L35.1031 37.1807L33.3113 34.1558L28.6887 34.078L30.913 30.1391L29.6572 28.0014L30.8806 25.835L35.5789 33.813L39.6267 33.761L32.8874 22.2812L36.3022 16.2341L33.4662 11.3857L30.0464 17.4417Z' fill='url(%23paint2_linear_908_35551)'/%3E%3Cpath d='M14.4209 45.1122L15.0603 43.9798L45.5167 43.6457L46.166 44.7915L14.4209 45.1122Z' fill='url(%23paint3_linear_908_35551)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35551' x='0' y='1.38574' width='59.4121' height='53.7266' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='5' result='effect1_foregroundBlur_908_35551'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35551' x1='26.387' y1='51.8695' x2='42.0125' y2='24.199' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35551' x1='26.387' y1='51.8695' x2='42.0125' y2='24.199' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_908_35551' x1='26.387' y1='51.8695' x2='42.0125' y2='24.199' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_908_35551' x1='26.387' y1='51.8695' x2='42.0125' y2='24.199' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-button__safe:hover,
.planet .focus__safe {
    height: 96px;
    width: 96px;
    top: -49px;
    left: 41%;
    background-size: contain;
    transition: background-image 0.3s ease-out, top 0.3s ease-out;
    background-image: url("data:image/svg+xml,%3Csvg width='119' height='106' viewBox='0 0 119 106' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_f_908_35550)'%3E%3Cpath d='M59.863 28.8941L31.9872 78.2583L19.48 78.3165L15 86.25L98.7237 85.426L103.204 77.4925L88.4592 77.6599L85.6144 72.9369L76.9479 73.1293L79.5382 77.7892L44.5565 78.0899L47.2943 73.2417L71.1798 73.0692L67.1698 66.2997L56.8247 66.1255L61.8025 57.3105L58.9922 52.5263L61.73 47.6781L72.2447 65.5324L81.3035 65.4161L66.2212 39.7248L73.8635 26.1914L67.5164 15.341L59.863 28.8941Z' fill='url(%23paint0_linear_908_35550)'/%3E%3Cpath d='M24.8937 90.8197L26.3249 88.2854L94.4852 87.5377L95.9381 90.102L24.8937 90.8197Z' fill='url(%23paint1_linear_908_35550)'/%3E%3C/g%3E%3Cpath d='M59.863 28.8941L31.9872 78.2583L19.48 78.3165L15 86.25L98.7237 85.426L103.204 77.4925L88.4592 77.6599L85.6144 72.9369L76.9479 73.1293L79.5382 77.7892L44.5565 78.0899L47.2943 73.2417L71.1798 73.0692L67.1698 66.2997L56.8247 66.1255L61.8025 57.3105L58.9922 52.5263L61.73 47.6781L72.2447 65.5324L81.3035 65.4161L66.2212 39.7248L73.8635 26.1914L67.5164 15.341L59.863 28.8941Z' fill='url(%23paint2_linear_908_35550)'/%3E%3Cpath d='M24.8937 90.8197L26.3249 88.2854L94.4852 87.5377L95.9381 90.102L24.8937 90.8197Z' fill='url(%23paint3_linear_908_35550)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35550' x='0' y='0.34082' width='118.203' height='105.479' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='7.5' result='effect1_foregroundBlur_908_35550'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35550' x1='51.6736' y1='105.942' x2='86.6429' y2='44.0167' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35550' x1='51.6736' y1='105.942' x2='86.6429' y2='44.0167' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_908_35550' x1='51.6736' y1='105.942' x2='86.6429' y2='44.0167' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_908_35550' x1='51.6736' y1='105.942' x2='86.6429' y2='44.0167' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-button__anonymous {
    top: 67.25px;
    left: 31px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-size: 58px;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='58' viewBox='0 0 60 58' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='30.003' cy='29.001' r='29.001' fill='white' fill-opacity='0.18'/%3E%3Cg filter='url(%23filter0_f_908_35554)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M46.5833 13.7115L47.3726 13.1855L50.002 13.1855L45.9753 19.9962L43.5646 19.9962L43.4099 19.9962L43.33 20.1291L35.9646 32.9748L35.906 33.0705L35.938 33.1767L36.6313 35.8011L30.002 47L23.3779 35.8011L24.0713 33.1767L24.098 33.0705L24.0446 32.9748L16.6793 20.1291L16.5993 19.9962L16.4446 19.9962L14.034 19.9962L10.002 13.1855L12.6366 13.1855L13.4259 13.7115L14.8087 13.7115L30.0157 39.5624L45.2227 13.7115L46.5833 13.7115Z' fill='url(%23paint0_linear_908_35554)'/%3E%3Cellipse cx='30.2687' cy='17.7812' rx='4.78131' ry='4.8' transform='rotate(-90 30.2687 17.7812)' fill='url(%23paint1_linear_908_35554)'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M46.5833 13.7115L47.3726 13.1855L50.002 13.1855L45.9753 19.9962L43.5646 19.9962L43.4099 19.9962L43.33 20.1291L35.9646 32.9748L35.906 33.0705L35.938 33.1767L36.6313 35.8011L30.002 47L23.3779 35.8011L24.0713 33.1767L24.098 33.0705L24.0446 32.9748L16.6793 20.1291L16.5993 19.9962L16.4446 19.9962L14.034 19.9962L10.002 13.1855L12.6366 13.1855L13.4259 13.7115L14.8087 13.7115L30.0157 39.5624L45.2227 13.7115L46.5833 13.7115Z' fill='url(%23paint2_linear_908_35554)'/%3E%3Cellipse cx='30.2687' cy='17.7812' rx='4.78131' ry='4.8' transform='rotate(-90 30.2687 17.7812)' fill='url(%23paint3_linear_908_35554)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35554' x='0.00195312' y='3' width='60' height='54' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='5' result='effect1_foregroundBlur_908_35554'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35554' x1='23.7688' y1='42.4483' x2='24.0673' y2='15.1353' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35554' x1='26.7746' y1='16.2852' x2='34.4983' y2='16.3847' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_908_35554' x1='23.7688' y1='42.4483' x2='24.0673' y2='15.1353' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_908_35554' x1='26.7746' y1='16.2852' x2='34.4983' y2='16.3847' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-button__anonymous:hover,
.planet .focus__anonymous {
    width: 96px;
    height: 96px;
    left: 31px;
    background-size: 96px;
    transition: background-image 0.3s ease-out;
    background-image: url("data:image/svg+xml,%3Csvg width='115' height='103' viewBox='0 0 115 103' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_f_908_35427)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M92.6459 16.5108L94.3213 15.3944L99.9022 15.3944L91.3554 29.8505L86.2386 29.8505L85.9103 29.8505L85.7405 30.1324L70.1072 57.3983L69.9827 57.6012L70.0506 57.8268L71.5222 63.3972L57.4511 87.1675L43.3913 63.3972L44.863 57.8268L44.9195 57.6012L44.8063 57.3983L29.173 30.1324L29.0032 29.8505L28.6749 29.8505L23.5581 29.8505L15 15.3944L20.5922 15.3944L22.2676 16.5108L25.202 16.5108L57.4797 71.3807L89.7574 16.5108L92.6459 16.5108Z' fill='url(%23paint0_linear_908_35427)'/%3E%3Cellipse cx='58.0164' cy='25.1483' rx='10.1486' ry='10.1883' transform='rotate(-90 58.0164 25.1483)' fill='url(%23paint1_linear_908_35427)'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M92.6459 16.5108L94.3213 15.3944L99.9022 15.3944L91.3554 29.8505L86.2386 29.8505L85.9103 29.8505L85.7405 30.1324L70.1072 57.3983L69.9827 57.6012L70.0506 57.8268L71.5222 63.3972L57.4511 87.1675L43.3913 63.3972L44.863 57.8268L44.9195 57.6012L44.8063 57.3983L29.173 30.1324L29.0032 29.8505L28.6749 29.8505L23.5581 29.8505L15 15.3944L20.5922 15.3944L22.2676 16.5108L25.202 16.5108L57.4797 71.3807L89.7574 16.5108L92.6459 16.5108Z' fill='url(%23paint2_linear_908_35427)'/%3E%3Cellipse cx='58.0164' cy='25.1483' rx='10.1486' ry='10.1883' transform='rotate(-90 58.0164 25.1483)' fill='url(%23paint3_linear_908_35427)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35427' x='0' y='-0.000488281' width='114.902' height='102.168' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='7.5' result='effect1_foregroundBlur_908_35427'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35427' x1='63.7375' y1='86.4414' x2='63.7375' y2='28.1517' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35427' x1='48.0731' y1='26.657' x2='64.5572' y2='26.657' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_908_35427' x1='63.7375' y1='86.4414' x2='63.7375' y2='28.1517' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_908_35427' x1='48.0731' y1='26.657' x2='64.5572' y2='26.657' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-button__alerts {
    top: 279.25px;
    left: -47px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-size: 58px;
    background-image: url("data:image/svg+xml,%3Csvg width='61' height='58' viewBox='0 0 61 58' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='30.0049' cy='29.001' r='29.001' fill='white' fill-opacity='0.18'/%3E%3Cg filter='url(%23filter0_f_908_35555)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.6412 45.9085L13.4306 45.381L27.7399 45.381L28.1665 44.3316H30.0118H31.8518L32.2838 45.381H46.5877L47.3771 45.9085H50.0117L45.9797 39.0788H43.5691H43.4144L43.3344 38.9456L35.9691 26.0641L35.9158 25.9683L35.9425 25.8617L36.6358 23.23L30.0118 12L23.3825 23.23L24.0759 25.8617L24.1079 25.9683L24.0492 26.0641L16.6839 38.9456L16.6039 39.0788H16.4492H14.0386L10.0119 45.9085H12.6412ZM36.6412 33.592H37.5798L33.3985 26.5014L33.1425 27.4763L36.6412 33.592ZM26.6196 26.5014L26.8809 27.4763L23.3823 33.592H22.4383L26.6196 26.5014Z' fill='url(%23paint0_linear_908_35555)'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.6412 45.9085L13.4306 45.381L27.7399 45.381L28.1665 44.3316H30.0118H31.8518L32.2838 45.381H46.5877L47.3771 45.9085H50.0117L45.9797 39.0788H43.5691H43.4144L43.3344 38.9456L35.9691 26.0641L35.9158 25.9683L35.9425 25.8617L36.6358 23.23L30.0118 12L23.3825 23.23L24.0759 25.8617L24.1079 25.9683L24.0492 26.0641L16.6839 38.9456L16.6039 39.0788H16.4492H14.0386L10.0119 45.9085H12.6412ZM36.6412 33.592H37.5798L33.3985 26.5014L33.1425 27.4763L36.6412 33.592ZM26.6196 26.5014L26.8809 27.4763L23.3823 33.592H22.4383L26.6196 26.5014Z' fill='url(%23paint1_linear_908_35555)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35555' x='0.0117188' y='2' width='60' height='53.9087' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='5' result='effect1_foregroundBlur_908_35555'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35555' x1='19.9309' y1='9.88072' x2='19.6263' y2='46.7585' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35555' x1='19.9309' y1='9.88072' x2='19.6263' y2='46.7585' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-button__alerts:hover,
.planet .focus__alerts {
    width: 96px;
    height: 96px;
    left: -47px;
    background-size: 96px;
    transition: background-image 0.3s ease-out;
    background-image: url("data:image/svg+xml,%3Csvg width='116' height='103' viewBox='0 0 116 103' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_f_908_35433)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.6121 87.383L22.2971 86.2571L52.8423 86.2571L53.753 84.0169H57.6921H61.6198L62.542 86.2571H93.0758L94.7607 87.383H100.385L91.7779 72.8041L86.6321 72.8041H86.3019L86.1312 72.5198L70.4089 45.0224L70.295 44.8178L70.3519 44.5903L71.832 38.9726L57.6921 15.0005L43.5409 38.9726L45.0209 44.5903L45.0892 44.8178L44.964 45.0224L29.2417 72.5198L29.071 72.8041H28.7408H23.5949L14.9994 87.383H20.6121ZM71.8434 61.09H73.8472L64.9216 45.954L64.3751 48.035L71.8434 61.09ZM50.451 45.954L51.0088 48.035L43.5404 61.09L41.5254 61.09L50.451 45.954Z' fill='url(%23paint0_linear_908_35433)'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.6121 87.383L22.2971 86.2571L52.8423 86.2571L53.753 84.0169H57.6921H61.6198L62.542 86.2571H93.0758L94.7607 87.383H100.385L91.7779 72.8041L86.6321 72.8041H86.3019L86.1312 72.5198L70.4089 45.0224L70.295 44.8178L70.3519 44.5903L71.832 38.9726L57.6921 15.0005L43.5409 38.9726L45.0209 44.5903L45.0892 44.8178L44.964 45.0224L29.2417 72.5198L29.071 72.8041H28.7408H23.5949L14.9994 87.383H20.6121ZM71.8434 61.09H73.8472L64.9216 45.954L64.3751 48.035L71.8434 61.09ZM50.451 45.954L51.0088 48.035L43.5404 61.09L41.5254 61.09L50.451 45.954Z' fill='url(%23paint1_linear_908_35433)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35433' x='0' y='0.000488281' width='115.385' height='102.382' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='7.5' result='effect1_foregroundBlur_908_35433'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35433' x1='51.37' y1='15.7327' x2='51.37' y2='74.5173' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35433' x1='51.37' y1='15.7327' x2='51.37' y2='74.5173' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-button__web {
    bottom: 105.24px;
    left: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-size: 58px;
    background-image: url("data:image/svg+xml,%3Csvg width='58' height='58' viewBox='0 0 58 58' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='29.0069' cy='29.001' r='29.001' fill='white' fill-opacity='0.18'/%3E%3Cg filter='url(%23filter0_f_908_35556)'%3E%3Cpath d='M43.0803 39.989L30.7105 18.8388L31.4219 10.7563L13.514 42.2017L26.8039 21.4752L27.6236 22.9097L28.0386 23.5694L29.2535 25.6466L24.1212 34.604L27.5217 34.5794L29.8375 30.7539L32.0464 34.5308L34.4444 34.5221L35.6593 36.5994L26.7041 36.6415L24.7766 40.0497L37.6523 40.007L41.0435 45.8054L46.4764 45.7958L43.0803 39.989Z' fill='url(%23paint0_linear_908_35556)'/%3E%3Cpath d='M30.7105 18.8388L31.1138 19.5285L28.372 24.1394L30.7105 18.8388Z' fill='url(%23paint1_linear_908_35556)'/%3E%3Cellipse cx='14.8146' cy='40.1249' rx='2.4591' ry='2.4591' transform='rotate(-90 14.8146 40.1249)' fill='url(%23paint2_linear_908_35556)'/%3E%3Cellipse cx='17.2743' cy='35.8194' rx='1.43447' ry='1.43447' transform='rotate(-90 17.2743 35.8194)' fill='url(%23paint3_linear_908_35556)'/%3E%3C/g%3E%3Cpath d='M43.0803 39.989L30.7105 18.8388L31.4219 10.7563L13.514 42.2017L26.8039 21.4752L27.6236 22.9097L28.0386 23.5694L29.2535 25.6466L24.1212 34.604L27.5217 34.5794L29.8375 30.7539L32.0464 34.5308L34.4444 34.5221L35.6593 36.5994L26.7041 36.6415L24.7766 40.0497L37.6523 40.007L41.0435 45.8054L46.4764 45.7958L43.0803 39.989Z' fill='url(%23paint4_linear_908_35556)'/%3E%3Cpath d='M30.7105 18.8388L31.1138 19.5285L28.372 24.1394L30.7105 18.8388Z' fill='url(%23paint5_linear_908_35556)'/%3E%3Cellipse cx='14.8146' cy='40.1249' rx='2.4591' ry='2.4591' transform='rotate(-90 14.8146 40.1249)' fill='url(%23paint6_linear_908_35556)'/%3E%3Cellipse cx='17.2743' cy='35.8194' rx='1.43447' ry='1.43447' transform='rotate(-90 17.2743 35.8194)' fill='url(%23paint7_linear_908_35556)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35556' x='2.35547' y='0.756348' width='54.1211' height='55.0488' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='5' result='effect1_foregroundBlur_908_35556'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35556' x1='16.0889' y1='20.1675' x2='31.6064' y2='46.6995' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35556' x1='16.0889' y1='20.1675' x2='31.6064' y2='46.6995' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_908_35556' x1='12.4052' y1='40.489' x2='16.3995' y2='40.489' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_908_35556' x1='15.8689' y1='36.0319' x2='18.1988' y2='36.0319' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint4_linear_908_35556' x1='16.0889' y1='20.1675' x2='31.6064' y2='46.6995' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint5_linear_908_35556' x1='16.0889' y1='20.1675' x2='31.6064' y2='46.6995' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint6_linear_908_35556' x1='12.4052' y1='40.489' x2='16.3995' y2='40.489' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint7_linear_908_35556' x1='15.8689' y1='36.0319' x2='18.1988' y2='36.0319' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23EADCEA'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-button__web:hover,
.planet .focus__web {
    width: 96px;
    height: 96px;
    bottom: 105.24px;
    left: 0;
    background-size: 96px;
    transition: background-image 0.3s ease-out, bottom 0.3s ease-out;
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='101' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_f_908_35422)'%3E%3Cpath d='M79.1569 75.5998L52.871 30.6557L54.3828 13.4805L16.3285 80.3017L44.5695 36.2581L46.3114 39.3063L47.1935 40.7082L49.7751 45.1223L38.8689 64.1568L46.0949 64.1044L51.0161 55.9754L55.71 64.0011L60.8058 63.9828L63.3874 68.3969L44.3575 68.4864L40.2616 75.7289L67.6224 75.638L74.8288 87.9596L86.3738 87.9393L79.1569 75.5998Z' fill='url(%23paint0_linear_908_35422)'/%3E%3Cpath d='M52.871 30.6557L53.7282 32.1214L47.9018 41.9194L52.871 30.6557Z' fill='url(%23paint1_linear_908_35422)'/%3E%3Cellipse cx='19.0947' cy='75.8662' rx='5.22558' ry='5.22558' transform='rotate(-90 19.0947 75.8662)' fill='url(%23paint2_linear_908_35422)'/%3E%3Ccircle cx='24.3217' cy='66.7213' r='3.04826' transform='rotate(-90 24.3217 66.7213)' fill='url(%23paint3_linear_908_35422)'/%3E%3C/g%3E%3Cpath d='M79.1569 75.5998L52.871 30.6557L54.3828 13.4805L16.3285 80.3017L44.5695 36.2581L46.3114 39.3063L47.1935 40.7082L49.7751 45.1223L38.8689 64.1568L46.0949 64.1044L51.0161 55.9754L55.71 64.0011L60.8058 63.9828L63.3874 68.3969L44.3575 68.4864L40.2616 75.7289L67.6224 75.638L74.8288 87.9596L86.3738 87.9393L79.1569 75.5998Z' fill='url(%23paint4_linear_908_35422)'/%3E%3Cpath d='M52.871 30.6557L53.7282 32.1214L47.9018 41.9194L52.871 30.6557Z' fill='url(%23paint5_linear_908_35422)'/%3E%3Cellipse cx='19.0947' cy='75.8662' rx='5.22558' ry='5.22558' transform='rotate(-90 19.0947 75.8662)' fill='url(%23paint6_linear_908_35422)'/%3E%3Ccircle cx='24.3217' cy='66.7213' r='3.04826' transform='rotate(-90 24.3217 66.7213)' fill='url(%23paint7_linear_908_35422)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_908_35422' x='0.869141' y='0.480469' width='98.5039' height='100.479' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='6.5' result='effect1_foregroundBlur_908_35422'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_908_35422' x1='21.8003' y1='33.4791' x2='54.7749' y2='89.8597' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_908_35422' x1='21.8003' y1='33.4791' x2='54.7749' y2='89.8597' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_908_35422' x1='13.9749' y1='76.64' x2='22.4627' y2='76.64' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_908_35422' x1='21.3351' y1='67.1727' x2='26.2863' y2='67.1727' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint4_linear_908_35422' x1='21.8003' y1='33.4791' x2='54.7749' y2='89.8597' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint5_linear_908_35422' x1='21.8003' y1='33.4791' x2='54.7749' y2='89.8597' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint6_linear_908_35422' x1='13.9749' y1='76.64' x2='22.4627' y2='76.64' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint7_linear_908_35422' x1='21.3351' y1='67.1727' x2='26.2863' y2='67.1727' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D574DE'/%3E%3Cstop offset='1' stop-color='%238E54E9'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
}

.planet-dark__top {
    position: absolute;
    top: 0;
    left: 58%;
    width: 411.162px;
    height: 520.023px;
    transform: rotate(-178.811deg);
    flex-shrink: 0;
    border-radius: 520.023px;
    background: #07041B;
    filter: blur(100px);
}

.planet-dark__bottom {
    position: absolute;
    left: 85px;
    top: 284px;
    width: 831.058px;
    height: 520.023px;
    transform: rotate(143.911deg);
    border-radius: 831.058px;
    background: #07041B;
    filter: blur(100px);
}

@media (min-width: 1800px) {
    .planet {
        width: 886.36px;
        height: 886.36px;
        top: 125px;
        left: 24px;
        background-size: contain;
    }

    .planet-button {
        width: 124px;
        height: 124px;
        background-size: 76px;
    }

    .planet-button__safe {
        top: -69px;
    }

    .planet-button__safe:hover,
    .planet .focus__safe {
        height: 129px;
        width: 132px;
        top: -69px;
        background-size: 124px;
    }

    .planet-button__anonymous {
        top: 88.25px;
        left: 46px;
    }

    .planet-button__anonymous:hover,
    .planet .focus__anonymous {
        height: 129px;
        width: 132px;
        left: 35px;
        background-size: 124px;
    }

    .planet-button__alerts {
        top: 365.25px;
        left: -64px;
    }

    .planet-button__alerts:hover,
    .planet .focus__alerts {
        height: 129px;
        width: 132px;
        left: -64px;
        background-size: 124px;
    }

    .planet-button__web {
        bottom: 118px;
        left: 21px;
    }

    .planet-button__web:hover,
    .planet .focus__web {
        height: 129px;
        width: 132px;
        bottom: 118px;
        left: 21px;
        background-size: 124px;
    }

    .planet-dark__top {
        width: 539.523px;
        height: 682.369px;
    }

    .planet-dark__bottom {
        width: 1090.505px;
        height: 682.369px;
    }
}

@media (min-width: 0px) and (max-width: 1290px) {
    .planet {
        top: 63px;
        left: 40px;
        width: 585.979px;
        height: 585.979px;
        border-radius: 585.979px;
        background-size: contain;
    }

    .planet-button {
        width: 80px;
        height: 80px;
        background-size: 50px;
    }

    .planet-button__safe {
        top: -41px;
    }

    .planet-button__safe:hover,
    .planet .focus__safe {
        height: 80px;
        width: 80px;
        top: -41px;
        background-size: 80px;
    }

    .planet-button__anonymous {
        top: 50.25px;
        left: 39px;
    }

    .planet-button__anonymous:hover,
    .planet .focus__anonymous {
        height: 80px;
        width: 80px;
        left: 45px;
        background-size: 80px;
    }

    .planet-button__alerts {
        top: 237.25px;
        left: -41px;
    }

    .planet-button__alerts:hover,
    .planet .focus__alerts {
        left: -41px;
        height: 80px;
        width: 80px;
        background-size: 80px;
    }

    .planet-button__web {
        bottom: 86.24px;
        left: 10.95px;
    }

    .planet-button__web:hover,
    .planet .focus__web {
        height: 80px;
        width: 80px;
        left: 10.95px;
        bottom: 86.24px;
        background-size: 80px;
    }

    .planet-dark__top {
        width: 356.683px;
        height: 451.119px;
    }

    .planet-dark__bottom {
        width: 720.941px;
        height: 451.119px;
    }
}

@media (max-width: 680px) {
    .planet {
        width: 281.692px;
        height: 281.692px;
        border-radius: 281.692px;
        left: 11px;
        top: 37px;
    }

    .planet-button {
        width: 40px;
        height: 40px;
        background-size: 24px;
    }

    .planet-button__safe {
        top: -20px;
        left: 41%;
    }

    .planet-button__safe:hover,
    .planet .focus__safe {
        top: -20px;
        left: 41%;
        width: 40px;
        height: 40px;
        background-size: 40px;
    }

    .planet-button__anonymous {
        top: 25.25px;
        left: 15.95px;
    }

    .planet-button__anonymous:hover,
    .planet .focus__anonymous {
        top: 25.25px;
        left: 15.95px;
        width: 40px;
        height: 40px;
        background-size: 40px;
    }

    .planet-button__alerts {
        top: 41%;
        left: -21px;
    }

    .planet-button__alerts:hover,
    .planet .focus__alerts {
        top: 41%;
        left: -16px;
        width: 40px;
        height: 40px;
        background-size: 40px;
    }

    .planet-button__web {
        bottom: 44.24px;
        left: 0;
    }

    .planet-button__web:hover,
    .planet .focus__web {
        bottom: 44.24px;
        left: 0px;
        width: 40px;
        height: 40px;
        background-size: 40px;
    }

    .planet-dark__top {
        display: block;
        width: 206.181px;
        height: 260.77px;
        filter: blur(48px);
    }

    .planet-dark__bottom {
        display: block;
        left: 15px;
        top: 110px;
        width: 349.631px;
        height: 218.777px;
        filter: blur(48px);
    }
}</style>